jQuery(document).ready(function ($) {
  // 使用事件委托来监听所有可能的点击

// =====================
// 货币转换工具
// =====================
const CurrencyUtils = {
  getActive() {
    return window.Shopify?.currency?.active || 'USD';
  },
  getRate() {
    return parseFloat(window.Shopify?.currency?.rate || '1.0');
  },

  // 传入美元金额（非 cents）
  convert(priceInDollars) {
    return priceInDollars * this.getRate();
  },

  format(priceInDollars) {
    const amount = this.convert(priceInDollars);
    const currency = this.getActive();
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  },
};

// 使用示例
// CurrencyUtils.format(2999)  → "€27.77"（当前货币为 EUR 时）
// CurrencyUtils.getActive()   → "EUR"
// CurrencyUtils.getRate()     → 1.08

// 切换英寸和厘米的按钮动作
document.querySelectorAll('.kuangao-input').forEach(function(container) {
  const options = container.querySelectorAll('.input-select div');
  const sizeLabels = container.querySelectorAll('.size_width');

options.forEach(function(option) {
  option.addEventListener('click', function() {
    const prevUnit = container.querySelector('.input-select .active').textContent.trim();
    const eighthsList = container.querySelectorAll('.span-eighths');
    const newUnit = this.textContent.trim();

    // 切换 active
    options.forEach(o => o.classList.remove('active'));
    this.classList.add('active');
    sizeLabels.forEach(label => label.textContent = newUnit);

    eighthsList.forEach(function(eighths) {
    if (newUnit === 'cm') {
          eighths.style.visibility = 'hidden'; // 隐藏，但仍占位，布局不变
          $('.wpcf7-not-valid-tip-min-all').html('Cordless is limited to 45-119.<br/>Motorized is limited to 58-238.');
          $('.wpcf7-not-valid-tip-max-all').html('Cordless is limited to 45-238.<br/>Motorized is limited to 45-381.');
        } else {
          eighths.style.visibility = '';       // 显示（恢复默认状态）
          $('.wpcf7-not-valid-tip-min-all').html('Cordless is limited to 18-47.<br/>Motorized is limited to 23-94.');
          $('.wpcf7-not-valid-tip-max-all').html('Cordless is limited to 18-94.<br/>Motorized is limited to 18-150.');
        }
      });
    // 转换已输入的数值
    if (prevUnit !== newUnit) {
      container.querySelectorAll('input[type="number"]').forEach(input => {
        if (input.value) {
          if (newUnit === 'cm') {
            input.value = (parseFloat(input.value) * 2.54).toFixed(2);
          } else {
            input.value = (parseFloat(input.value) / 2.54).toFixed(2);
          }
        }
      });
    }
  handleCurtainCalculation(false);
  });
});
});

// 限定在当前产品价格容器内读取，避免读到其他产品卡片的价格
const $productPrice = $(".product__price .price");

// 划线原价：s 标签本身有 price-item--regular 这个 class
const $strikethroughEl = $productPrice.find("s.price-item--regular");

// 现价
const $salePriceEl = $productPrice.find(".price-item--sale.price-item--last");

// 无折扣时的价格
const $regularOnlyEl = $productPrice.find(".price__regular .price-item--regular");

if ($strikethroughEl.length > 0) {
    originalVariantRegularPrice = parseFloat($strikethroughEl.first().text().replace(/[^0-9.]/g, '')) || 0;
    originalVariantSalePrice = parseFloat($salePriceEl.first().text().replace(/[^0-9.]/g, '')) || 0;
} else {
    originalVariantRegularPrice = parseFloat($regularOnlyEl.first().text().replace(/[^0-9.]/g, '')) || 0;
    originalVariantSalePrice = originalVariantRegularPrice;
}

console.log('初始原价(划线):', originalVariantRegularPrice, '初始售价:', originalVariantSalePrice);
    
  let originalQuantity = 1;
  var productInputs = {};
  //产品详情页价格获取
  var $initPrice = $(".product__price .price .price-item").html();
  //获取元字段数据
  const metafieldsJson = document.getElementById("product-metafields");
  let metafields = {};
  if (metafieldsJson) {
        metafields = JSON.parse(metafieldsJson.textContent);
    }

// ===== 表单有效性 + 加购拦截（与时序无关）=====
    let formValid = false;

    // 统一入口：设置内部状态 + 视觉禁用
    function setFormValidity(valid) {
        console.log("测试:" + valid);
        formValid = !!valid;
        const $btn = $(".product-form__submit");
        $btn.prop("disabled", !formValid).toggleClass("disabled", !formValid);
    }

    (function setupCartGuard() {
        const SUBMIT_SELECTOR = '.product-form__submit';
        const FORM_SELECTOR = 'product-form form, form[action*="/cart/add"]';

        // 1) 提交拦截：挂在 document 捕获阶段（委托），表单被重渲染也依然生效，且覆盖所有加购表单
        document.addEventListener('submit', function (e) {
            const form = e.target;
            if (form && form.matches && form.matches(FORM_SELECTOR)) {
                // 白名单：换色卡加购不拦截
                if (form.matches('#swatch-form')) return;

                // 提交前最后同步一次 Liner Color，确保不为空（捕获阶段，早于主题序列化 FormData）
                if (window.syncLinerColor) window.syncLinerColor();

                if (!formValid) {
                    e.preventDefault();
                    e.stopImmediatePropagation();   // 阻止主题自带的 AJAX 加购
                    alert("Please fill in all required fields!");
                }
            }
        }, true);

        // 2) 视觉自愈：监听整个 body，谁把按钮启用了、而表单还无效，就把【所有】加购按钮禁回去
        let scheduled = false;
        function enforce() {
            scheduled = false;
            if (formValid) return;                  // 表单有效就不干预，交给正常流程
            document.querySelectorAll(SUBMIT_SELECTOR).forEach(function (btn) {
                if (!btn.disabled) {
                    btn.disabled = true;
                    btn.classList.add('disabled');
                }
            });
        }
        new MutationObserver(function () {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(enforce);         // 合并同一帧的多次变动，避免抖动和性能问题
        }).observe(document.body, {
            attributes: true,
            attributeFilter: ['disabled', 'class'],
            childList: true,
            subtree: true
        });
    })();
// ===== 表单有效性 代码到此结束=====  

function updatePriceDisplay(newPrice, inputs, mode) {
  const $priceWrapper = $(".product__price .price");
  const quantity = inputs.quantity || 1;

  function formatPrice(price) {
    return CurrencyUtils.format(price.toFixed(2));
  }

  // 使用页面加载时保存的原始价格计算折扣比例
  const discountRatio = (originalVariantRegularPrice > 0 && originalVariantSalePrice > 0 && originalVariantSalePrice < originalVariantRegularPrice)
    ? originalVariantSalePrice / originalVariantRegularPrice
    : 1;

  const calculatedSalePrice = newPrice;
  const calculatedRegularPrice = discountRatio < 1
    ? newPrice / discountRatio
    : 0;

  function getPanelText(price) {
    if (inputs.panelType === "Split Panels") {
      return `${quantity} × ${formatPrice(price)}`;
    } else {
      if (price > 0) {
        const panel = quantity > 1 ? 'pieces' : 'Piece';
        return `${quantity} ${panel} × ${formatPrice(price)}`;
      } else {
        return $initPrice;
      }
    }
  }

  if (discountRatio < 1 && calculatedRegularPrice > 0) {
    $priceWrapper.removeClass('price--no-sale').addClass('price--on-sale');
    $priceWrapper.find('s.price-item--regular').html(formatPrice(calculatedRegularPrice));
    $priceWrapper.find('.price__sale .price-item--sale').html(getPanelText(calculatedSalePrice));
    const saveAmount = calculatedRegularPrice - calculatedSalePrice;
    $priceWrapper.find('.price__badge-sale').text('Save ' + formatPrice(saveAmount));
  } else {
    $priceWrapper.removeClass('price--on-sale').addClass('price--no-sale');
    $priceWrapper.find('.price__regular .price-item--regular').html(getPanelText(calculatedSalePrice));
  }

  $("#fetch_color_res_txt").html(inputs.colorSwatch || "");
  $("#fetch_width_res_txt").html(inputs.width ? inputs.width.toFixed(2) + '"' : "");
  $("#fetch_length_res_txt").html(inputs.height ? inputs.height.toFixed(2) + '"' : "");
  $("#fetch_header_res_txt").html(inputs.header || "");
  $("#fetch_lining_res_txt").html(inputs.lining || "");
}

function handleCurtainCalculation(isAddToCart = false, updatePriceStr = "") {
    // 获取所有必要的输入值
    const inputs = {
      productId: $('input[name="product-id"]').val(),
      variation_id: $('input[name="id"]').val() || 0,
      colorSwatch: $(".variant-picker__color").val() || "",
      method: $('input[name="mtsi_method"]:checked').val(),
      header: $('input[name="mtsi_header_type"]:checked').val(),
      width: parseFloat($("#mtsi_custom_curtain_width").val()),
      height: parseFloat($("#mtsi_custom_curtain_height").val()),
      width_eighths: $("select[name='width_eighths']").val(),
      height_eighths: $("select[name='height_eighths']").val(),
      unit: 'inches',
      panelType: $('input[name="mtsi_panel_type"]:checked').val(),
      mountType: $('input[name="mtsi_mount_type"]:checked').val(),
      liftControl: $('input[name="mtsi_lift_control"]:checked').val(),
      edgeBinding: $('input[name="mtsi_edge_binding"]:checked').val(),
      liningOption: $('input[name="mtsi_lining_option"]:checked').val(),
      quantity: parseInt($('.quantity input[name="quantity"]').val() || "1"),
      lining: $('input[data-name="mtsi_custom_curtain_lining"]:checked').val(),
      liningColor:
        $('input[data-name="mtsi_liner_color_swatch"]:checked').attr(
          "data-color-name"
        ) || "",
      linerUnitPrice: parseFloat(metafields.liner_unit_price) || 0,
      fabricUnitPrice: parseFloat(metafields.fabric_unit_price) || 0,
      gramPerSquareInches: parseFloat(metafields.gram_per_square_inches) || 0,
      linerGramPerSquareInches: parseFloat(metafields.liner_gram_per_square_inches) || 0,
      isLining: metafields.liners || "",
      patternType: "vertical",
      exchangeRate: parseFloat(1 / 7.0),
      startValue: 'YES',
    };
    productInputs = inputs;

    const variantData = JSON.parse(
      document.querySelector('variant-selects script[type="application/json"]').textContent
    );

    // 获取当前选中的 Color 值
    const selectedColor = document.querySelector('input[name="Color"]:checked')?.value;

    // 找到对应变体
    const currentVariant = variantData.find(v => v.option1 === selectedColor);
    const currentSku = currentVariant?.sku;

    console.log('当前SKU:', currentSku);
    // Split Panels 数量调整
    if (updatePriceStr != "") {
      if (inputs.panelType == "Split Panels") {
        inputs.quantity *= 2;
      }
    } else {
      if (inputs.panelType === "Split Panels") {
        if (inputs.quantity * 2 == originalQuantity) {
          inputs.quantity *= 2;
        }
      } else {
        if (inputs.quantity === originalQuantity) {
          inputs.quantity = originalQuantity;
          $('input[name="quantity"]').val(inputs.quantity);
        }
      }
    }

    // ============================================================
    // 新计算公式
    // ============================================================
    let craftWidth  = parseFloat(inputs.width);   // inch
    let craftHeight = parseFloat(inputs.height);  // inch
        const activeUnit = document.querySelector('.input-select .active').textContent.trim();

        if (activeUnit === 'cm') {
        craftWidth = parseFloat((craftWidth / 2.54).toFixed(2));
        craftHeight = parseFloat((craftHeight / 2.54).toFixed(2));
        }
    const fabricUnitPrice     = inputs.fabricUnitPrice;      // RMB/平方米
    const gramPerSqIn         = inputs.gramPerSquareInches;  // g/平方英寸
    const isMotorized         = inputs.liftControl === 'Motorized';
    const hasEdgeBinding      = inputs.edgeBinding && inputs.edgeBinding !== 'No Edge Binding';
    const hasLining           = inputs.lining && inputs.lining !== 'Unlined';

    // G2 面料成本 = MAX(宽m × 高m, 1) × 面料单价
    const widthM   = craftWidth  * 0.0254;
    const heightM  = craftHeight * 0.0254;
    const realArea = widthM * heightM;
    const billedArea = Math.max(realArea, 1);  // 不足1平方米按1算
    const fabricCost = billedArea * fabricUnitPrice;
    console.log("G2 fabricCost:", fabricCost);

    // H2 分拼费：幅数 N = ROUNDUP(宽m / 1.8, 0)
    // N=1: 0元  N=2: 7元  N=3: 9元  N>=2: 7+(N-2)*2
    const panelCount = Math.ceil(widthM / 1.8);
    const splicingFee = panelCount >= 2 ? 7 + (panelCount - 2) * 2 : 0;
    console.log("H2 panelCount:", panelCount, "splicingFee:", splicingFee);

    // I2 总重量KG = (宽inch × 高inch × 克重g/sqin) / 1000 + 1 + IF(电动, 0.5×幅数, 0)
    const fabricWeightKg = (craftWidth * craftHeight * gramPerSqIn) / 1000;
    const motorWeightKg  = isMotorized ? 0.5 * panelCount : 0;
    const totalWeightKg  = fabricWeightKg + 1 + motorWeightKg;
    console.log("I2 totalWeightKg:", totalWeightKg);

    // 完整运费合同（向上匹配）
    const shippingTable = [
      [0.5,  264.865], [1.0,  281.26],  [1.5,  297.915], [2.0,  340.7],
      [2.5,  383.251], [3.0,  407.433], [3.5,  446.747], [4.0,  486.061],
      [4.5,  525.375], [5.0,  564.689], [5.5,  548.935], [6.0,  584.115],
      [6.5,  619.295], [7.0,  654.475], [7.5,  689.655], [8.0,  724.835],
      [8.5,  760.015], [9.0,  795.195], [9.5,  830.375], [10.0, 865.555],
      [10.5, 995.154], [11.0, 1032.479],[11.5, 1069.804],[12.0, 1107.129],
      [12.5, 1144.454],[13.0, 1181.779],[13.5, 1219.104],[14.0, 1256.429],
      [14.5, 1293.754],[15.0, 1331.079],[15.5, 1368.404],[16.0, 1405.729],
      [16.5, 1443.054],[17.0, 1480.379],[17.5, 1517.704],[18.0, 1555.029],
      [18.5, 1592.354],[19.0, 1629.68], [19.5, 1667.00], [20.0, 1704.33],
      [20.5, 1990.70], [21.0, 2021.65], [21.5, 2052.61], [22.0, 2083.56],
      [22.5, 2114.52], [23.0, 2145.47], [23.5, 2176.43], [24.0, 2207.38],
      [24.5, 2238.34], [25.0, 2269.29], [25.5, 2300.25], [26.0, 2331.20],
      [26.5, 2362.16], [27.0, 2393.11], [27.5, 2424.07], [28.0, 2455.02],
      [28.5, 2485.98], [29.0, 2516.93], [29.5, 2547.89], [30.0, 2578.84],
    ];

    // J2 运费：向上取整匹配（totalWeightKg 超过某档则取下一档）
    function getFreight(weightKg) {
      for (let i = 0; i < shippingTable.length; i++) {
        if (weightKg <= shippingTable[i][0]) {
          return shippingTable[i][1];
        }
      }
      // 超出最大档位，取最大值
      return shippingTable[shippingTable.length - 1][1];
    }
    const freight = getFreight(totalWeightKg);
    console.log("J2 freight:", freight);

    // K2 超长附加费：宽高中最大值 > 48 inch 加 90 元
    const surcharge = (Math.max(craftWidth, craftHeight) > 48) ? 90 : 0;
    console.log("K2 surcharge:", surcharge);

    // M2 包边费：选了包边时，高度 ≤ 2m 加15元，> 2m 加30元
    const edgeBindingFee = hasEdgeBinding ? (heightM <= 2 ? 15 : 30) : 0;
    console.log("M2 edgeBindingFee:", edgeBindingFee);

    // O2 电机费 = 359 + MAX(面积, 1) × 10
    const motorFee = isMotorized ? (359 + billedArea * 10) : 0;
    console.log("O2 motorFee:", motorFee);

    // Q2 衬布费 = MAX(面积, 1) × 55（不足1平米按1平米）
    const liningFee = hasLining ? (billedArea * 55) : 0;
    console.log("Q2 liningFee:", liningFee);

    // R2 总成本USD = (G + H + J + K + M + O + Q) / 7
    const totalCostUSD = (fabricCost + splicingFee + freight + surcharge + edgeBindingFee + motorFee + liningFee) / 7;
    console.log("R2 totalCostUSD:", totalCostUSD);

    // S2 最终售价 = R2 × 4
    //20260413 利润系数从4改成2.5倍
    //20260501 利润系数从2.5改成3.5倍
    //20260521 利润系数从3.5改成4倍
    let totalPrice = totalCostUSD * 4;
    totalPrice = Math.floor(totalPrice * 100) / 100;
    console.log("S2 totalPrice:", totalPrice);

    inputs.totalPrice = totalPrice;

    // ============================================================
    // 传值到隐藏表单、更新UI（保持不变）
    // ============================================================
    document.getElementById('hiddenMountType').value = inputs.mountType ?? '';
    if (activeUnit === 'cm') {
    document.getElementById('hiddenWidth').value = inputs.width + 'cm' ?? '';
    document.getElementById('hiddenHeight').value = inputs.height + 'cm' ?? '';      
    }else{
    document.getElementById('hiddenWidth').value = inputs.width + ' ' + inputs.width_eighths + '"' ?? '';
    document.getElementById('hiddenHeight').value = inputs.height + ' ' + inputs.height_eighths + '"' ?? '';
    }
    document.getElementById('hiddenLiftControl').value = inputs.liftControl ?? '';
    document.getElementById('hiddenLining').value = inputs.lining ?? '';
    document.getElementById('hiddenLinerColor').value = inputs.liningColor ?? '';
    document.getElementById('hiddenEdgeBinding').value = inputs.edgeBinding ?? '';

    // 提交前最后同步一次 Liner Color，确保不为空（捕获阶段，早于主题序列化 FormData）
    if (window.syncLinerColor) window.syncLinerColor();

    var appPriceInput = document.getElementById('custom-price-field');
    if (appPriceInput) {
      appPriceInput.value = totalPrice;
    }

    $(".new-xqy .color").html(inputs.colorSku);
    $(".new-xqy .mountType").html(inputs.mountType);
    $(".new-xqy .liftControl").html(inputs.liftControl);
    $(".new-xqy .lining").html(inputs.lining);
    $(".new-xqy .edge_binding").html(inputs.edgeBinding);

    if (inputs.width && inputs.height) {
      if (activeUnit === 'cm') {
      $(".width_height_html").html(inputs.width + 'cm W x ' + inputs.height + 'cm L');        
      }else{
      $(".width_height_html").html(inputs.width + ' ' + inputs.width_eighths + '"W x ' + inputs.height + ' ' + inputs.height_eighths + '"L');
      }
      $('.kuangao').css('border', 'none');
    } else {
      $(".width_height_html").html('');
      $('.kuangao').css('border', '1px dashed red');
    }

    if (inputs.mountType == 'Inside') {
      $('.kuangao-img img').attr("src", 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-measuring-min.png?v=1766975679');
      $('.note-text').html('. Width: Measure widths at top, middle, and bottom inside the window; use the smallest one & deduct 3/8".<br> · Length: Measure heights at left, center, right inside the window; use the largest measurement.');
      $('input[value="Cordless"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-manual-cordless-min.png?v=1766742344');
      $('input[value="Motorized"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Inside-Mount-motorized-min.png?v=1766742381');
    } else if (inputs.mountType == 'Outside') {
      $('.kuangao-img img').attr("src", 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-measuring-min.png?v=1766975874');
      $('.note-text').html('· Width: Measure widths at top, middle, and bottom inside the window; use the largest one and add  2-4 inches for optimal coverage.<br> · Height: Measure from your desired mounting point down to the desired bottom. Recommend: 4-6 inches above the window frame.');
      $('input[value="Cordless"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-manual-cordless-min.png?v=1766975915');
      $('input[value="Motorized"]').siblings('span').find('img')
        .attr('src', 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/Outside-Mount-motorized-min.png?v=1766975945');
    }

    //C款产品不能选择衬布
    if (currentSku.includes('-c-')) {
      $('input[data-name="mtsi_custom_curtain_lining"][value="Liner"]').prop("disabled", true);
    }

    //产品元字段有数据时，根据元字段判断是否显示衬布
    if(inputs.isLining){
      if(inputs.isLining == 'Unlined'){
          $('input[data-name="mtsi_custom_curtain_lining"][value="Liner"]').prop("disabled", true);
      }
    }

    // 获取当前模板的名称
    const templateClass = [...document.body.classList]
      .find(c => c.startsWith('template-'));
    // → "template-product-curtains-bamboo-xidamen"

    // 解析出模板名和 suffix
    const parts = templateClass.replace('template-', '').split('-');
    const templateName = parts[0];        // "product"
    const templateSuffix = parts.slice(1).join('-'); // "curtains-bamboo-xidamen"
    //判断当前的模板是西大门模板，隐藏衬布
    if(templateSuffix == 'curtains-bamboo-xidamen'){
      $('input[data-name="mtsi_liner_color_swatch"][value="#f4ebcd"]').closest('label.liner-color-radio').hide();
      $('input[data-name="mtsi_liner_color_swatch"][value="#d6ccbe"]').closest('label.liner-color-radio').hide();
      $('input[data-name="mtsi_liner_color_swatch"][value="#dbdbdb"]').closest('label.liner-color-radio').hide();
      $('input[data-name="mtsi_liner_color_swatch"][value="#bcbcbc"]').closest('label.liner-color-radio').hide();
      $('input[data-name="mtsi_liner_color_swatch"][value="#000000"]').closest('label.liner-color-radio').hide();
    }

    checkAllOptionsSelected(activeUnit);
    if (totalPrice) {
      updatePriceDisplay(totalPrice, inputs, inputs.startValue);
    }
  }
  //初始化计算
  handleCurtainCalculation();
  //分界线
  function checkAllOptionsSelected(activeUnit) {
    var allSelected = true;

    if (!productInputs.mountType || !productInputs.liftControl) {
      allSelected = false;
    }

    // Check if width and height are entered and valid

    var minwidthValue = 18;
    var minheightValue = 18;
    var maxValue = 94;
    var maxHeight = 150;
    if (activeUnit === 'cm') {
      minwidthValue = 18*2.54;
      minheightValue = 18*2.54;
      maxValue = 94*2.54;
      maxHeight = 150*2.54;
    }
    if (!(productInputs.width && productInputs.width >= minwidthValue && productInputs.width <= maxValue && productInputs.height && productInputs.height >= minheightValue && productInputs.height <= maxHeight)) {
      allSelected = false;
    }

  let width  = Number(productInputs.width);
  let height = Number(productInputs.height);

  // 删除旧的提示（兼容原有逻辑）
  document.querySelectorAll(".option-warning").forEach(el => el.remove());

  // ----- Cordless 限制：宽 18-70，高 18-94 -----
  let cordlessWidthOk  = width  >= 18 && width  <= 47;
  let cordlessHeightOk = height >= 18 && height <= 94;
  if (activeUnit === 'cm') {
    cordlessWidthOk  = width  >= 18*2.54 && width  <= 47*2.54;
    cordlessHeightOk = height >= 18*2.54 && height <= 94*2.54;
  }

  if (!cordlessWidthOk || !cordlessHeightOk) {
    let reasons = [];
    if (activeUnit === 'cm') {
    if (!cordlessWidthOk)  reasons.push(`Width must be 45–119" (current: ${width}")`);
    if (!cordlessHeightOk) reasons.push(`Height must be 45–238" (current: ${height}")`);      
    }else{
    if (!cordlessWidthOk)  reasons.push(`Width must be 18–47" (current: ${width}")`);
    if (!cordlessHeightOk) reasons.push(`Height must be 18–94" (current: ${height}")`);
    }
    disableRadioItem('Cordless', reasons.join(' | '));
    $(".new-xqy .liftControl").html('');
  } else {
    enableRadioItem('Cordless');
    $(".new-xqy .liftControl").html(productInputs.liftControl);
    console.log('cordless 占位');
  }

  // ----- Motorized 限制：宽 23-94，高 18-150 -----
  let motorizedWidthOk  = width  >= 23 && width  <= 94;
  let motorizedHeightOk = height >= 18 && height <= 150;
  if (activeUnit === 'cm') {
   motorizedWidthOk  = width  >= 23*2.54 && width  <= 94*2.54;
   motorizedHeightOk = height >= 18*2.54 && height <= 150*2.54;    
  }
  if (!motorizedWidthOk || !motorizedHeightOk) {
    let reasons = [];
    if (activeUnit === 'cm') {
    if (!motorizedWidthOk)  reasons.push(`Width must be 58–238" (current: ${width}")`);
    if (!motorizedHeightOk) reasons.push(`Height must be 45–381" (current: ${height}")`);      
    }else{
    if (!motorizedWidthOk)  reasons.push(`Width must be 23–94" (current: ${width}")`);
    if (!motorizedHeightOk) reasons.push(`Height must be 18–150" (current: ${height}")`);
    }
    disableRadioItem('Motorized', reasons.join(' | '));
    $(".new-xqy .liftControl").html('');
  } else {
    enableRadioItem('Motorized');
    $(".new-xqy .liftControl").html(productInputs.liftControl);
    console.log('motorized 占位');
  }
    //限制尺寸不符合的加入购物车
  setFormValidity(allSelected);
}
  //添加提示语，PC端鼠标移动显示
  const style = document.createElement('style');
  style.textContent = `
    .wpcf7-list-item {
      position: relative;
      display: inline-block;
    }

    .wpcf7-list-item.is-disabled {
      opacity: 0.9;
      cursor: not-allowed;
    }

    .wpcf7-list-item.is-disabled label {
      pointer-events: none;
    }

    .wpcf7-list-item.is-disabled::before {
      content: attr(data-disable-reason);
      position: absolute;
      left: 0;
      top: 0;
      color: #ff0101;
      border-radius: 4px;
      white-space: normal;
      font-size: 12px;
      line-height: 1.4;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s;
      text-align: center;
      z-index: 999;
    }

    .wpcf7-list-item.is-disabled::after {
      content: '';
      position: absolute;
      bottom: calc(100% + 2px);
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-top-color: #333;
      opacity: 0;
      transition: opacity 0.2s;
      z-index: 999;
    }

    .wpcf7-list-item.is-disabled:hover::before,
    .wpcf7-list-item.is-disabled:hover::after {
      opacity: 1;
    }

    .disable-click-tip {
      position: absolute;
      bottom: -24px;
      left: 50%;
      transform: translateX(-50%);
      color: #e74c3c;
      font-size: 12px;
      white-space: nowrap;
      opacity: 0;
      transition: opacity 0.3s;
      pointer-events: none;
    }

    .disable-click-tip.show {
      opacity: 1;
    }
  `;
  document.head.appendChild(style);


// ========== 提示在移动端点击显示 ==========
function disableRadioItem(value, reason) {
  const input = document.querySelector(`input[name="mtsi_lift_control"][value="${value}"]`);
  if (!input) return;

  const listItem = input.closest('.wpcf7-list-item');
  if (!listItem) return;

  input.disabled = true;
  input.checked = false;
  listItem.classList.add('is-disabled');
  listItem.setAttribute('data-disable-reason', reason);

  // 避免重复绑定：先移除旧监听
  if (listItem._disableClickHandler) {
    listItem.removeEventListener('click', listItem._disableClickHandler);
  }

  // 添加点击提示元素
  let tip = listItem.querySelector('.disable-click-tip');
  if (!tip) {
    tip = document.createElement('span');
    tip.className = 'disable-click-tip';
    listItem.appendChild(tip);
  }
  tip.textContent = reason;

  // 绑定点击事件
  listItem._disableClickHandler = (e) => {
    e.preventDefault();
    tip.classList.add('show');
    clearTimeout(tip._timer);
    tip._timer = setTimeout(() => tip.classList.remove('show'), 2500);
  };
  listItem.addEventListener('click', listItem._disableClickHandler);
}


// ========== 启用方法 ==========
function enableRadioItem(value) {
  const input = document.querySelector(`input[name="mtsi_lift_control"][value="${value}"]`);
  if (!input) return;

  const listItem = input.closest('.wpcf7-list-item');
  if (!listItem) return;

  input.disabled = false;
  listItem.classList.remove('is-disabled');
  listItem.removeAttribute('data-disable-reason');

  // 移除点击监听
  if (listItem._disableClickHandler) {
    listItem.removeEventListener('click', listItem._disableClickHandler);
    delete listItem._disableClickHandler;
  }

  // 移除提示元素
  const tip = listItem.querySelector('.disable-click-tip');
  if (tip) tip.remove();
}


  //加入购物车，已弃用
  function addToCart(adjustedInputs, totalPrice) {
    // 检查是否所有必要的字段都已填写
    if (
      !adjustedInputs.mountType ||
      !adjustedInputs.liftControl ||
      isNaN(adjustedInputs.width) ||
      isNaN(adjustedInputs.height)
    ) {
      alert("Please fill in all required fields!");
      return;
    }

    if (!adjustedInputs.colorSwatch) {
      alert("Please choose a color");
      return false;
    }
    const cartData = {
      action: "cstm_add_to_cart",
      product_id: adjustedInputs.productId,
      variation_id: adjustedInputs.variation_id,
      msti_pattern_type: adjustedInputs.patternType,
      mtsi_color_sku: adjustedInputs.colorSku,
      mtsi_color_swatch: adjustedInputs.colorSwatch,
      mtsi_mount_type: adjustedInputs.mountType,
      mtsi_lift_control: adjustedInputs.liftControl,
      mtsi_custom_curtain_width: adjustedInputs.width,
      mtsi_custom_curtain_height: adjustedInputs.height,
      width_eighths: adjustedInputs.width_eighths,
      height_eighths: adjustedInputs.height_eighths,
      mtsi_custom_curtain_unit: adjustedInputs.unit,
      quantity: adjustedInputs.quantity,
      mtsi_custom_curtain_lining: adjustedInputs.lining,
      mtsi_custom_curtain_lining_color: adjustedInputs.liningColor,
      security: ajax_object.nonce,
      calculated_price: totalPrice,
      startValue: adjustedInputs.startValue,
    };

    $.ajax({
      url: ajax_object.ajax_url,
      type: "POST",
      data: cartData,
      beforeSend: function () {
        var $addToCartButton = $(".single_add_to_cart_button");
        $addToCartButton.prop("disabled", true);
        $addToCartButton.addClass("disabled");
      },
      success: function (response) {
        if (response.success) {
          localStorage.setItem("NEWCARTADDITEM", "1");
          location.reload();
        } else {
          alert(response.data.msg);
          var $addToCartButton = $(".single_add_to_cart_button");
          $addToCartButton.prop("disabled", false);
          $addToCartButton.removeClass("disabled");
        }
      },
      error: function (xhr, status, error) {
        alert("An error occurred: " + error);
        var $addToCartButton = $(".single_add_to_cart_button");
        $addToCartButton.prop("disabled", false);
        $addToCartButton.removeClass("disabled");
      },
    });
  }

  var $addToCartButton = $(".single_add_to_cart_button");
  $addToCartButton.on("click", function (e) {
    handleCurtainCalculation(false);
    e.preventDefault();
    addToCart(productInputs, productInputs.totalPrice);
  });
  //加入购物车到此结束

  $('input[name="mtsi_mount_type"] , input[name="mtsi_lift_control"] ,input[data-name="mtsi_custom_curtain_lining"], #mtsi_custom_curtain_width , #mtsi_custom_curtain_height , select[name="width_eighths"] , select[name="height_eighths"], input[name="mtsi_edge_binding"], .quantity input.quantity__input').on("change", function () {
    handleCurtainCalculation(false);
  });

    //变体颜色切换会把价格更改成变体价格，需要等待shopify的更改价格函数执行后，才可以触发更改价格
$('input[name="Color"]').on("change", function () {        
    setTimeout(() => {
        const $productPrice = $(".product__price .price");
        const $newStrikethrough = $productPrice.find("s.price-item--regular");
        const $newSalePrice = $productPrice.find(".price-item--sale.price-item--last");
        
        if ($newStrikethrough.length > 0) {
            originalVariantRegularPrice = parseFloat($newStrikethrough.first().text().replace(/[^0-9.]/g, '')) || 0;
            originalVariantSalePrice = parseFloat($newSalePrice.first().text().replace(/[^0-9.]/g, '')) || 0;
        } else {
            originalVariantRegularPrice = parseFloat($productPrice.find(".price__regular .price-item--regular").first().text().replace(/[^0-9.]/g, '')) || 0;
            originalVariantSalePrice = originalVariantRegularPrice;
        }
        console.log('变体切换后 - 原价:', originalVariantRegularPrice, '售价:', originalVariantSalePrice);
        handleCurtainCalculation(false);
    }, 1000);
});

  $('#mtsi_custom_curtain_width , #mtsi_custom_curtain_height').keypress(function(event){
    handleCurtainCalculation(false);
    if (event.which === 13) {
      event.preventDefault();
    }
  })
  //失去焦点时
  $('#mtsi_custom_curtain_width , #mtsi_custom_curtain_height').blur(function(){
          const activeUnit = document.querySelector('.input-select .active').textContent.trim();
          let min_width = 18;
          let max_width = 94;
          let min_height = 18;
          let max_height = 150;
          if(activeUnit == 'cm'){
            min_width = 45;
            max_width = 238;
            min_height = 45;
            max_height = 381;
          }
          if($("#mtsi_custom_curtain_width").val()){
            $('.wpcf7-not-valid-tip1').css('visibility','hidden');
          }else{
            $('.wpcf7-not-valid-tip1').css('visibility','visible');
          }
          if($("#mtsi_custom_curtain_width").val() && $("#mtsi_custom_curtain_width").val() < min_width || $("#mtsi_custom_curtain_width").val() > max_width){
            $('.wpcf7-not-valid-tip-min-all').css('display','block');
            $('.wpcf7-not-valid-tip1').css('display','none');
          }else{
            $('.wpcf7-not-valid-tip-min-all').css('display','none');
            $('.wpcf7-not-valid-tip1').css('display','none');
          }
          if($("#mtsi_custom_curtain_height").val()){
            $('.wpcf7-not-valid-tip2').css('visibility','hidden');
          }else{
            $('.wpcf7-not-valid-tip2').css('visibility','visible');
          }
          if($("#mtsi_custom_curtain_height").val() && $("#mtsi_custom_curtain_height").val() < min_height || $("#mtsi_custom_curtain_height").val() > max_height){
            $('.wpcf7-not-valid-tip-max-all').css('display','block');
            $('.wpcf7-not-valid-tip2').css('display','none');
          }else{
            $('.wpcf7-not-valid-tip-max-all').css('display','none');
            $('.wpcf7-not-valid-tip2').css('display','none');
          }
    handleCurtainCalculation(false);
  });

  var exec5 = 0;

  setTimeout(function () {
    if (exec5 == 0) {
      exec5 = 1;

      if (localStorage.getItem("NEWCARTADDITEM")) {
        $(".lakit-cart__heading-link").click();

        localStorage.removeItem("NEWCARTADDITEM");
      }

      if (
        $("form.woocommerce-checkout ul.uael-order-review-table li + a")
          .length
      ) {
        $(
          "form.woocommerce-checkout ul.uael-order-review-table li.table-row.cart_item.st-item-meta > a:first-child"
        ).remove();

        $("form.woocommerce-checkout ul.uael-order-review-table li + a").each(
          function () {
            $(this).remove();
          }
        );
      }
    }
  }, 1500);

});
